import { Graph } from "./generic-graph";
import { VerticalGraph } from "./vertical-views";


export interface HorizontalGraphView extends Graph {
  data: HorizontalItemRow[];
}

export interface HorizontalItemRow {
  title: String;
  value: HorizontalItemRowAmount;
  kmt: HorizontalItemRowAmount;
  price: HorizontalItemRowAmount;
  data?: HorizontalItemRowData;
}

interface HorizontalItemRowAmount {
  value: number;
  positive: number; //-1 0 1
}

export interface HorizontalItemRowData {
  fields: HorizontalItemRowDataField[]; //amount of items needs to match columns in graphs. all graphs MUST have the same amount of columns
  graphs: HorizontalItemRowDataGraphs;
}

//new
export interface HorizontalItemRowDataGraphs {
  kmt: VerticalGraph;
  dollarMT: VerticalGraph;
  mDollar: VerticalGraph;
}

//new (previously was HorizontalItemRowData)
export interface HorizontalItemRowDataField {
  kmt: HorizontalItemRowDataItem;
  dollarMT: HorizontalItemRowDataItem;
  mDollar: HorizontalItemRowDataItem;
}

interface HorizontalItemRowDataItem {
  sales: number; 
  salesCompare?: number; 
  positive: number //-1 0 1
}

export enum SalesUnits {
  kmt = 'KMT',
  dollarMT = '$/MT',
  mDollar = 'M$',
}
